import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuCheckboxItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

const teamSizes = [
  { label: "1-10", min: 1, max: 10 },
  { label: "11-50", min: 11, max: 50 },
  { label: "51-200", min: 51, max: 200 },
  { label: "201+", min: 201, max: Infinity },
];

interface TeamSizeFilterProps {
  selectedSizes: string[];
  onTeamSizeChange: (sizes: string[]) => void;
}

export function TeamSizeFilter({ selectedSizes, onTeamSizeChange }: TeamSizeFilterProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          Team Size
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-40">
        <DropdownMenuLabel>Team Size</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {teamSizes.map((size) => (
          <DropdownMenuCheckboxItem
            key={size.label}
            checked={selectedSizes.includes(size.label)}
            onCheckedChange={(checked) => {
              const newSizes = checked
                ? [...selectedSizes, size.label]
                : selectedSizes.filter((s) => s !== size.label);
              onTeamSizeChange(newSizes);
            }}
          >
            {size.label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}